import { render, staticRenderFns } from "./JwtAuthForm.vue?vue&type=template&id=5bc07a0c&scoped=true"
import script from "./JwtAuthForm.vue?vue&type=script&lang=js"
export * from "./JwtAuthForm.vue?vue&type=script&lang=js"
import style0 from "./JwtAuthForm.vue?vue&type=style&index=0&id=5bc07a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc07a0c",
  null
  
)

export default component.exports